import Header from "@/components/landing/Header";
import Faq, { FAQ_ITEMS } from "@/components/landing/Faq";
import Footer from "@/components/landing/Footer";
import Seo from "@/components/Seo";

export default function FaqPage() {
  return (
    <>
      <Seo
        title="FAQ: Häufige Fragen zur Auswanderung nach Florida"
        description="Antworten auf die häufigsten Fragen von Deutschen und Schweizern: Visum, Firmengründung in Florida, Ablauf der Zusammenarbeit, Betreuung nach der Auswanderung und Kosten."
        keywords="Auswandern Florida FAQ, Visum Fragen, Firmengründung Florida Fragen, E-2 Visum Fragen, Auswanderung USA Fragen"
        jsonLd={{
          "@type": "FAQPage",
          mainEntity: FAQ_ITEMS.map((item) => ({
            "@type": "Question",
            name: item.question,
            acceptedAnswer: { "@type": "Answer", text: item.answer },
          })),
        }}
      />
      <Header />
      <main className="pt-20" data-testid="faq-page">
        <Faq />
      </main>
      <Footer />
    </>
  );
}
